export const MESSAGE_THRESHOLD_END_INDEX = 1

export const MESSAGES_API_PARAM_PAGE_SIZE = 10
